export default "__VITE_ASSET__18726e01__"